import { fetchLoggedInUserOrganizationDetails } from '../api/loginApi';
import { creators } from '../ducks/organizationDuck';
import { logoutAction } from './auth';

export const fetchOrganizationAction = token => async (dispatch, _getState) => {
  dispatch(creators.fetch());
  try {
    const response = await fetchLoggedInUserOrganizationDetails({
      token,
    });
    dispatch(creators.fetchSuccess(response));
  } catch (error) {
    dispatch(logoutAction());
    dispatch(creators.fetchFailed(error));
    throw error;
  }
};
